module.exports = __webpack_public_path__ + "static/media/6.f53dc3d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_110/images/九宫格未选中态/6.png
// module id = 1067
// module chunks = 0